module.exports = __webpack_public_path__ + "static/1project-8b25dac3d575a918596551e0ed4839ce.png";